import { MEMBERSHIP_PAID_TIERS_ENABLED } from "@shared/membershipPaidTiers";

export type SignupAccountType = "free" | "paid";

export function resolveSignupCompletion(accountType: SignupAccountType, returnTo?: string) {
  if (MEMBERSHIP_PAID_TIERS_ENABLED && accountType === "paid") return { kind: "checkout" as const };
  return { kind: "navigate" as const, destination: returnTo ?? "/my-events" };
}
